import React from 'react'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import MainContainer from '../components/homepage/MainContainer';

const HomePage = () => {
    const navigate = useNavigate();

    const onSignOut = () => {
        localStorage.removeItem('tkn');
        navigate('/signin');
    };

    return (
        <Stack alignItems="center" sx={{flex: 1, height: '100%'}}>
            <Header bg borderBottom>
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        position: 'relative',
                        paddingX: 2,
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="h5" fontWeight="600" color="#ccffff" ml={2}>
                        Auto Platform
                    </Typography>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'right', flex: 1}}>
                        <Button variant="outlined" onClick={() => navigate('/report')} sx={{mr: 2}}>
                            <Typography variant="button" color="#ccffff">
                                View Report
                            </Typography>
                        </Button>
                        <Button variant="outlined" onClick={() => navigate('/history')} sx={{mr: 2}}>
                            <Typography variant="button" color="#ccffff">
                                View History
                            </Typography>
                        </Button>
                        <Button variant="outlined" onClick={() => navigate('/preserve')} sx={{mr: 2}}>
                            <Typography variant="button" color="#ccffff">
                                View Preserve
                            </Typography>
                        </Button>
                        <IconButton onClick={onSignOut}>
                            <LogoutOutlinedIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Header>
            <MainContainer/>
        </Stack>
    );
};

export default HomePage;
